import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (loading) return null;

  if (location.pathname === '/signup' || location.pathname === '/verify-email') {
    return <Outlet />;
  }
  
  if (isAuthenticated) {
    return <Navigate to={safeNextPath(searchParams.get('next')) || '/dashboard'} replace />;
  }

  return <Outlet />;
};

const safeNextPath = (value) => {
  if (!value || typeof value !== 'string') return null;
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  if (value.startsWith('/login') || value.startsWith('/signup')) return null;
  return value;
};

export default PublicRoute;
